class GetContractReportReq {
    constructor(){
        this.ContractId = undefined;
        this.Date = {
            StartDate: undefined,
            EndDate: undefined
        };
    }
}

export default GetContractReportReq;